/* PULERA 3.0 — hero video gating + Gentle Monster style header state. Deferred, no dependencies. */
(function () {
  var desktop = window.matchMedia('(min-width: 990px)').matches;
  var scroller = desktop ? document.querySelector('.page-wrapper') : null;
  var saveData = (navigator.connection && navigator.connection.saveData) ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Hero video: load + play only the visible breakpoint variant, only when in view. */
  var videos = document.querySelectorAll('video[data-pl-src]');
  if (videos.length && 'IntersectionObserver' in window && !saveData) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        var wrapper = v.closest('.pl-hero__media-wrapper, .hero__media-wrapper');
        if (wrapper && getComputedStyle(wrapper).display === 'none') return;
        var slide = v.closest('.pl-hero__slide');
        if (slide && !slide.classList.contains('is-active')) return;
        if (entry.isIntersecting) {
          if (!v.getAttribute('src')) { v.setAttribute('src', v.dataset.plSrc); v.load(); }
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (v.getAttribute('src')) {
          v.pause();
        }
      });
    }, { root: scroller, threshold: 0.05 });
    videos.forEach(function (v) { io.observe(v); });
  }

  /* 1b. Hero slider: crossfade, swipe, ORIGIN-mark dots, optional autoplay. Only the active slide's video runs. */
  var heroEl = document.querySelector('.pl-hero--slider');
  if (heroEl) {
    var hSlides = Array.prototype.slice.call(heroEl.querySelectorAll('.pl-hero__slide'));
    var hDots = Array.prototype.slice.call(heroEl.querySelectorAll('.pl-hero__dot'));
    var hCur = 0, hTimer = null, hInView = true;
    var hInterval = (parseInt(heroEl.getAttribute('data-pl-autoplay'), 10) || 0) * 1000;
    var visibleVideos = function (slide) {
      return Array.prototype.filter.call(slide.querySelectorAll('video[data-pl-src]'), function (v) {
        var w = v.closest('.pl-hero__media-wrapper');
        return w && getComputedStyle(w).display !== 'none';
      });
    };
    var hGo = function (i, byUser) {
      i = (i + hSlides.length) % hSlides.length;
      hSlides.forEach(function (sl, k) {
        var on = k === i;
        sl.classList.toggle('is-active', on);
        if (on) { sl.removeAttribute('aria-hidden'); sl.removeAttribute('inert'); }
        else { sl.setAttribute('aria-hidden', 'true'); sl.setAttribute('inert', ''); Array.prototype.forEach.call(sl.querySelectorAll('video'), function (v) { v.pause(); }); }
      });
      hDots.forEach(function (d, k) { d.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      hCur = i;
      if (!saveData && hInView) visibleVideos(hSlides[i]).forEach(function (v) {
        if (!v.getAttribute('src')) { v.setAttribute('src', v.dataset.plSrc); v.load(); }
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      });
      if (byUser) hRestart();
    };
    var hRestart = function () {
      if (hTimer) { clearInterval(hTimer); hTimer = null; }
      /* Rotation is independent of reduced-motion / Data Saver (those only gate the videos and the crossfade). */
      if (hInterval && hSlides.length > 1) hTimer = setInterval(function () { if (!document.hidden && hInView) hGo(hCur + 1); }, hInterval);
    };
    hDots.forEach(function (d, k) { d.addEventListener('click', function () { hGo(k, true); }); });
    heroEl.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { hGo(hCur + 1, true); e.preventDefault(); }
      else if (e.key === 'ArrowLeft') { hGo(hCur - 1, true); e.preventDefault(); }
    });
    var sx = 0, sy = 0, swiping = false;
    heroEl.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse' && e.button !== 0) return; sx = e.clientX; sy = e.clientY; swiping = true; }, { passive: true });
    heroEl.addEventListener('pointerup', function (e) {
      if (!swiping) return; swiping = false;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) hGo(hCur + (dx < 0 ? 1 : -1), true);
    }, { passive: true });
    heroEl.addEventListener('pointercancel', function () { swiping = false; }, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { hInView = entries[0].isIntersecting; }, { root: scroller, threshold: 0.05 }).observe(heroEl);
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) hRestart(); });
    hRestart();
  }

  /* 2. Header: stay transparent while the hero is under it, frosted glass once the hero has scrolled away. */
  var header = document.getElementById('header-component');
  var main = document.getElementById('MainContent');
  var hero = main && main.querySelector(':scope > .shopify-section:first-child :is(.pl-hero, .hero)');
  if (header && header.hasAttribute('transparent') && hero && 'IntersectionObserver' in window) {
    var headerHeight = header.offsetHeight || 90;
    var io2 = new IntersectionObserver(function (entries) {
      header.classList.toggle('pl-over-hero', entries[0].isIntersecting);
    }, { root: scroller, rootMargin: '-' + headerHeight + 'px 0px 0px 0px', threshold: 0 });
    io2.observe(hero);
  }

  /* 2b. Home: the bar stays transparent all the way down; text + logo go white over video/dark ground and black
        over light ground. Three points under the bar (menu, logo, icons) vote; ties go to black. */
  if (header && header.hasAttribute('data-pl-adaptive') && document.elementsFromPoint) {
    var plLum = function (c) {
      var m = c && c.match(/[\d.]+/g); if (!m || m.length < 3) return null;
      if (m.length > 3 && parseFloat(m[3]) < 0.5) return null;
      return (0.2126 * m[0] + 0.7152 * m[1] + 0.0722 * m[2]) / 255;
    };
    var plToneOf = function (el) {
      for (var e = el; e && e !== document.documentElement; e = e.parentElement) {
        if (e.hasAttribute('data-pl-tone')) return e.getAttribute('data-pl-tone');
        if (e.matches('video, .pl-hero, .hero, .pl-hero__media, .hero__media')) return 'dark';
        var l = plLum(getComputedStyle(e).backgroundColor);
        if (l !== null) return l < 0.55 ? 'dark' : 'light';
      }
      return 'light';
    };
    var plSample = function () {
      var r = header.getBoundingClientRect();
      var y = Math.max(1, r.top + r.height / 2);
      var w = window.innerWidth, dark = 0, n = 0;
      [56, w / 2, w - 56].forEach(function (x) {
        var els = document.elementsFromPoint(x, y);
        for (var i = 0; i < els.length; i++) {
          if (header.contains(els[i]) || els[i].closest('.header-section, .cart-drawer, dialog')) continue;
          n++; if (plToneOf(els[i]) === 'dark') dark++; break;
        }
      });
      var t = dark * 2 > n ? 'dark' : 'light';
      if (header.getAttribute('data-pl-tone') !== t) header.setAttribute('data-pl-tone', t);
    };
    var plTick = false;
    var plOnScroll = function () { if (!plTick) { plTick = true; requestAnimationFrame(function () { plTick = false; plSample(); }); } };
    (scroller || window).addEventListener('scroll', plOnScroll, { passive: true });
    window.addEventListener('resize', plOnScroll);
    window.addEventListener('load', plSample);
    plSample();
  }

  /* 3. Reveal: sections below the fold and product cards fade up once as they enter (GM-style). Class is added
        here, not in Liquid, so a page without JS renders fully visible. */
  if ('IntersectionObserver' in window && !saveData) {
    var revealTargets = [];
    var sections = main ? main.querySelectorAll(':scope > .shopify-section:not(:first-child)') : [];
    Array.prototype.forEach.call(sections, function (s) { revealTargets.push(s); });
    Array.prototype.forEach.call(document.querySelectorAll('.product-grid__item, .resource-list__item'), function (card, i) {
      if (!card.closest('.cart-drawer, [data-pl-no-reveal]')) revealTargets.push(card);
    });
    var vh = window.innerHeight || 800;
    revealTargets.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.9) return; /* already on screen at load: never hide what the visitor can see */
      el.classList.add('pl-reveal');
      var siblings = el.parentNode ? Array.prototype.indexOf.call(el.parentNode.children, el) : 0;
      if (el.classList.contains('product-grid__item') || el.classList.contains('resource-list__item')) el.style.transitionDelay = ((siblings % 4) * 70) + 'ms';
    });
    var pending = revealTargets.filter(function (el) { return el.classList.contains('pl-reveal'); });
    var show = function (el) { el.classList.add('pl-in'); io3.unobserve(el); };
    /* Anything the visitor has already scrolled past (fast flick, anchor jump, restored scroll position) must never stay hidden. */
    var sweep = function () {
      var limit = (window.innerHeight || 800) * 0.92;
      pending = pending.filter(function (el) {
        if (el.getBoundingClientRect().top < limit) { show(el); return false; }
        return true;
      });
      if (!pending.length) (scroller || window).removeEventListener('scroll', onScroll);
    };
    var ticking = false;
    var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; sweep(); }); } };
    var io3 = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) show(entry.target); });
      sweep();
    }, { root: scroller, rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    pending.forEach(function (el) { io3.observe(el); });
    (scroller || window).addEventListener('scroll', onScroll, { passive: true });
  }
})();
